import {
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Portal,
  Spinner,
} from '@chakra-ui/react';
import * as React from 'react';

import { ChevronDownIcon } from '@/imports/ui/chakra/feather';

export type MembersSortValue = 'default' | 'name-asc' | 'name-desc';

export const MEMBERS_SORT_OPTIONS: {
  value: MembersSortValue;
  label: string;
}[] = [
  { value: 'default', label: 'Default' },
  { value: 'name-asc', label: 'Name (A–Z)' },
  { value: 'name-desc', label: 'Name (Z–A)' },
];

export const DEFAULT_MEMBERS_SORT: MembersSortValue = 'default';

type IMembersSortDropdownProps = {
  value: MembersSortValue;
  onChange: (value: MembersSortValue) => void;
  isLoading?: boolean;
};

export const MembersSortDropdown: React.FC<IMembersSortDropdownProps> = ({
  value,
  onChange,
  isLoading = false,
}) => {
  const selectedLabel =
    MEMBERS_SORT_OPTIONS.find((option) => option.value === value)?.label ||
    MEMBERS_SORT_OPTIONS[0].label;

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="outline"
        colorScheme="gray"
        fontWeight="normal"
        borderRadius="full"
        rightIcon={
          isLoading ? (
            <Spinner color="gray.600" size="sm" />
          ) : (
            <ChevronDownIcon />
          )
        }
        flexShrink={0}
        whiteSpace="nowrap"
        isDisabled={isLoading}
        aria-label="Sort members"
        aria-busy={isLoading}
      >
        {`Sort: ${selectedLabel}`}
      </MenuButton>
      <Portal>
        <MenuList minW="220px">
          <MenuOptionGroup
            type="radio"
            value={value}
            onChange={(nextValue) => onChange(nextValue as MembersSortValue)}
          >
            {MEMBERS_SORT_OPTIONS.map((option) => (
              <MenuItemOption key={option.value} value={option.value}>
                {option.label}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Portal>
    </Menu>
  );
};
